import React, { useEffect, useState } from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Table } from "antd";
import type { TableColumnsType } from 'antd';
import axios from "axios";
import "./data_subs.css";
import { useNavigate } from "react-router-dom";

interface SubsDataType {
    id: number;
    no_subs: string;
    date: string;
    no_po: string;
    sales: string;
    cs_name: string;
}

const DataSubs: React.FC = () => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const navigate = useNavigate();
    const [data, setData] = useState<SubsDataType[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/substitution/get-all-subs`);
                setData(response.data);
            } catch (error) {
                console.error("Failed to fetch substitution data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const columns: TableColumnsType<SubsDataType> = [
        {
            title: 'No Subs',
            dataIndex: 'no_subs',
            key: 'no_subs',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'No PO',
            dataIndex: 'no_po',
            key: 'no_po',
        },
        {
            title: 'Customer Name',
            dataIndex: 'cs_name',
            key: 'cs_name',
        },
        {
            title: 'Sales',
            dataIndex: 'sales',
            key: 'sales',
        },
    ];


    return (

        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="imfe">
                <div className="gjs-grid-column" id="in1a">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: (
                                    <>
                                        <span>Data Subs</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/sales_substitution",
                                title: "Sales Substitution",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="i7a5v">
                <div className="gjs-grid-column" id="iq81z">
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        bordered
                        onRow={(record) => {
                            return {
                                onClick: () => {
                                     navigate('/dashboard/sales_substitution', { state: { no_subs: record.no_subs } });
                                },
                            };
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default DataSubs;